import React from "react";

import cn from "classnames";
import { useTranslation } from "react-i18next";

import { CopyOutlined, FileExcelOutlined, FileTextOutlined, RetweetOutlined } from "@ant-design/icons";
import { Button, message, Space, Tooltip } from "antd";

import { ReportFormat } from "../../../store/common_types";
import { Inscription } from "../../inscription";

import styles from "./styles.module.scss";

export interface ButtonsSectionsProps {
  loading?: boolean;
  reportDownloadDisabled?: boolean;
  className?: string;
  onReload: () => void;
  onDownloadReport?: (reportFormat: ReportFormat) => void;
}

export const ButtonsSection: React.FC<ButtonsSectionsProps> = (props) => {
  const { t } = useTranslation("buttons_section");
  const { loading, reportDownloadDisabled, onReload, onDownloadReport, className } = props;

  const copyURL = () => {
    navigator.clipboard.writeText(window.location.href).then(async () => {
      await message.success(t("copy.message"));
    });
  };

  return (
    <div>
      <Inscription title={t("title.actions")} className={cn([styles.inscription, styles.actions])}>
        <Space className={cn([styles.buttons, className])}>
          <Tooltip title={t("refresh")}>
            <Button onClick={onReload}>
              <RetweetOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={t("copy.tooltip")}>
            <Button onClick={copyURL}>
              <CopyOutlined />
            </Button>
          </Tooltip>
        </Space>
      </Inscription>
      {onDownloadReport && (
        <Inscription title={t("title.reports")} className={styles.inscription}>
          <Space className={cn([styles.buttons, className])}>
            <Tooltip title={t("csv")}>
              <Button disabled={loading || reportDownloadDisabled} onClick={() => onDownloadReport("csv")}>
                <FileTextOutlined />
              </Button>
            </Tooltip>
            <Tooltip title={t("excel")}>
              <Button disabled={loading || reportDownloadDisabled} onClick={() => onDownloadReport("xlsx")}>
                <FileExcelOutlined />
              </Button>
            </Tooltip>
          </Space>
        </Inscription>
      )}
    </div>
  );
};
